'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCombinations = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDisplayableValues = function getDisplayableValues(values) {
  return R.filter(function (val) {
    return !R.includes(R.prop('id', val), _constants.REJECTED_VALUE_IDS) && R.propOr(true, 'display', val);
  }, values);
};

// invalid concepts:
// - empty/null/undefined/!array values (so far)
var hasInvalidValues = R.pipe(R.prop('values'), R.anyPass([R.isNil, R.complement(R.is(Array)), R.isEmpty]));
var isConceptInvalid = R.anyPass([hasInvalidValues /* add more... */]);
var filterValidConcepts = R.reject(isConceptInvalid);
// concepts is an array of ids... (misnamed!)
var rejectInvalidConceptIds = function rejectInvalidConceptIds() {
  var concepts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function () {
    var combinations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var validConceptIds = R.pluck('id', filterValidConcepts(concepts));
    return R.reduce(function (acc, comb) {
      var refinedConcepts = R.intersection(validConceptIds, comb.concepts);
      if (R.length(refinedConcepts) < 1) {
        return acc;
      }
      return R.append((0, _extends4.default)({}, comb, { concepts: refinedConcepts }), acc);
    }, [], combinations);
  };
};

var parseCombinations = exports.parseCombinations = function parseCombinations(combinations, parsedAttributes, dimensions) {
  var concepts = R.concat(dimensions, parsedAttributes);

  var indexedDimensions = R.indexBy(R.prop('id'), dimensions);
  var indexedAttributes = R.indexBy(R.prop('id'), parsedAttributes);

  return R.pipe(rejectInvalidConceptIds(concepts), R.reduce(function (acc, comb) {
    var relationship = [];
    var ids = {};
    var displayable_values_count = 0;
    var seriesConcepts = R.filter(function (concept) {
      if (R.has(concept, ids)) {
        return false;
      }
      if (R.has(concept, indexedDimensions)) {
        var dimension = R.prop(concept, indexedDimensions);
        relationship = !dimension.header ? R.append(concept, relationship) : relationship;
        ids = (0, _extends4.default)({}, ids, (0, _defineProperty3.default)({}, concept, concept));
        displayable_values_count += R.length(dimension.values || []);
        return !dimension.header;
      } else if (!R.has(concept, indexedAttributes)) {
        return false;
      }
      var attribute = R.prop(concept, indexedAttributes);
      var displayableValues = getDisplayableValues(attribute.values || []);
      var isDisplayable = R.length(displayableValues) !== 0 && R.propOr(true, 'display', attribute);
      relationship = attribute.series && isDisplayable ? R.pipe(R.reject(function (id) {
        return R.has(id, ids);
      }), R.concat(relationship))(attribute.relationship) : relationship;
      ids = attribute.series && isDisplayable ? (0, _extends4.default)({}, ids, R.indexBy(R.identity, attribute.relationship)) : ids;
      displayable_values_count = isDisplayable ? displayable_values_count + R.length(displayableValues) : displayable_values_count;
      return attribute.series && isDisplayable;
    }, comb.concepts);
    if (R.isEmpty(seriesConcepts)) {
      return R.append((0, _extends4.default)({}, comb, { header: true, display: displayable_values_count > 0 }), acc);
    }
    return R.append((0, _extends4.default)({}, comb, {
      series: true,
      relationship: relationship,
      display: displayable_values_count > 0
    }), acc);
  }, []))(combinations);
};